import { useGlobalContext } from "../../../../Context/Context";
import Zaposleni from "./Zaposleni";

function PoslovnaJedinica() {
  const { selectedPoslovnaJedinica } = useGlobalContext();

  if (!selectedPoslovnaJedinica) return null;

  return (
    <div style={{ backgroundColor: "white", height: "100%" }}>
      <Zaposleni />
    </div>
  );
}

export default PoslovnaJedinica;
